import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { AppPage } from "shared-ts-ui-app-page";
import { Box, Stack, Typography } from "@mui/material";

export const NoBuildingsPage: FC = () => {
  const { t } = useTranslation("my-chimney-ts-translations");

  return (
    <AppPage
      $key={"NoBuildingsPage"}
      name={"No Buildings"}
      hideName
      mainPane={
        <Box
          sx={{
            flexGrow: 1,
            minWidth: 0,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Stack
            direction={"column"}
            useFlexGap
            gap={1}
            sx={{ alignSelf: "center" }}
          >
            <Typography>{`${t("You have no buildings available")}`}</Typography>
          </Stack>
        </Box>
      }
    />
  );
};
